import { ButtonBase } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement
} from "react";
import styles from "./MenuList.module.less";
import { Key } from "client/Misc/commonTypes";
import { useKeyboardGridNavigationItem } from "client/Hooks/useKeyboardGridNavigation";

export type MenuListProps = {
	trackingId?: string;
};

export const MenuList = (props: PropsWithChildren<MenuListProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{children}
		</ul>
	);
};
MenuList.displayName = "MenuList";

export type MenuListItemProps = {
	image: ReactElement;
	title: string;
	onClick(): void;
	trackingId: string;
	index: number;
	tabbableIndex?: number;
};

const MenuListItem = (props: MenuListItemProps): ReactElement => {
	const {
		image,
		onClick,
		title,
		trackingId,
		index,
		tabbableIndex
	} = props;

	const {
		ref,
		onKeyDown
	} = useKeyboardGridNavigationItem({
		index,
		onExecute: onClick,
		executeKey: [Key.Enter, Key.Space]
	});

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.item}
		>
			<ButtonBase
				ref={ref}
				onClick={onClick}
				className={styles.button}
				onKeyDown={onKeyDown}
				tabIndex={tabbableIndex === index ? 0 : -1}
			>
				{image}
				<span
					{...setTrackingId("title")}
					className={styles.title}
				>
					{title}
				</span>
			</ButtonBase>
		</li>
	);
};
MenuListItem.displayName = "MenuList.Item";

MenuList.Item = MenuListItem;